import React, { useEffect, useRef, useState } from "react";
import {
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
  Typography,
  Divider,
  Button,
  Box,
  ListItemButton,
} from "@mui/material";
import moment from "moment";
import { ReactComponent as ChevronDown } from "../../assets/Icons/chevron-down.svg";

const CustomMenu = ({
  currentStatus,
  createdAt,
  onUpdateStatus,
  statusOptions,
  statusLabels,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);
  const [selectionId, setSelectionId] = useState(currentStatus);

  useEffect(() => {
    const idx = statusOptions?.findIndex(
      (option) => option?.value === currentStatus
    );
    if (idx !== -1) {
      setSelectionId(idx);
    }
  }, [currentStatus, statusOptions]);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const handleToggle = () => setOpen((prev) => !prev);
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === "Tab" || event.key === "Escape") setOpen(false);
  };

  const currDate = moment();
  const dateToTest = moment(createdAt);
  const isRecent = currDate.diff(dateToTest, "days") <= 3;

  const getColor = () => statusOptions[selectionId]?.color;

  const getVariant = () => statusOptions[selectionId]?.variant || "outlined";

  const renderLabel = () => {
    if (!currentStatus) return "Fully Booked";
    return statusLabels[currentStatus] || "Fully Booked";
  };

  const handleStatusChange = (ev, value) => {
    onUpdateStatus(value);
    handleClose(ev);
  };

  return (
    <>
      <Button
        ref={anchorRef}
        fullWidth
        size="small"
        disableRipple
        variant={getVariant()}
        color={getColor() || "error"}
        onClick={handleToggle}
        aria-controls={open ? "composition-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        disabled={disabled}
        sx={{
          borderRadius: 20,
          textTransform: "capitalize",
          gap: 0.75,
          px: 1,
          alignItems: "center",
          fontWeight: 600,
        }}
      >
        {renderLabel()}
        {currentStatus && (
          <Box sx={{ color: isRecent ? "" : "text.secondary" }}>
            <ChevronDown />
          </Box>
        )}
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        sx={{ zIndex: 1 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: "left top" }}>
            <Paper
              sx={{
                border: "1px solid",
                borderColor: "border.main",
                boxShadow: "0px 0px 32px rgba(0, 0, 0, 0.08)",
                borderRadius: 1.5,
                minWidth: 267,
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  {statusOptions.map((option, idx) => (
                    <Box key={option.value}>
                      {idx !== 0 && <Divider sx={{ my: 1 }} />}
                      <MenuItem sx={{ p: 0 }}>
                        <ListItemButton
                          onClick={(ev) => {
                            setSelectionId(idx);
                            handleStatusChange(ev, option.value);
                          }}
                          sx={{ py: 1, px: 2, gap: 0.5 }}
                        >
                          {option.icon}
                          <Typography variant="body2" component="span">
                            {option.label}
                          </Typography>
                        </ListItemButton>
                      </MenuItem>
                    </Box>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default CustomMenu;
